// extracted by mini-css-extract-plugin
export var blog_menu = "BlogMenu-module--blog_menu--blo3e";
export var blog_menu__wrapper = "BlogMenu-module--blog_menu__wrapper--fbzyW";
export var tags = "BlogMenu-module--tags--9d9Kt";
export var tag = "BlogMenu-module--tag--V6ajb";
export var blog_menu_toggler = "BlogMenu-module--blog_menu_toggler--+Fy-z";
export var active = "BlogMenu-module--active--a09w7";
export var blog_menu_aside = "BlogMenu-module--blog_menu_aside--xFQeb";
export var show = "BlogMenu-module--show--OhIUE";
export var blog_menu_aside__header = "BlogMenu-module--blog_menu_aside__header--tQ03e";
export var close_icon = "BlogMenu-module--close_icon--9f+0A";
export var blog_menu_aside__tags = "BlogMenu-module--blog_menu_aside__tags--xL-1P";
export var blog_menu_aside__tag = "BlogMenu-module--blog_menu_aside__tag--qQ7nd";
export var search = "BlogMenu-module--search--DbH0U";
export var search_bar = "BlogMenu-module--search_bar--3Szxn";
export var search_icon = "BlogMenu-module--search_icon--mkqnL";
export var not_mobile = "BlogMenu-module--not_mobile--t7Yk6";
export var mobile = "BlogMenu-module--mobile--5duoL";